<template>
  <div>
    <file-list :fileType="2" :fileList="fileList"></file-list>
  </div>
</template>

<script>
import fileList from "../../components/fileList";
export default {
  name: "",
  components: { fileList },
  props: {},
  data() {
    return {
      fileList: [
        {
          name: "思政微课项目申报书.docx",
          byte: "32KB",
          download: "思政微课项目申报书.docx",
        },
        {
          name: "特色文化育人品牌项目申报书.docx",
          byte: "22KB",
          download: "特色文化育人品牌项目申报书.docx",
        },
        {
          name: "思政教育工作室项目申报书.docx",
          byte: "52KB",
          download: "思政教育工作室项目申报书.docx",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    const file = JSON.parse(window.sessionStorage.getItem('departs'))[0].twoFiles
    this.fileList = file.split(',').map(item => {
      let pos = item.lastIndexOf(".");
      let lastName = item.substring(pos, item.length);
      return {
        name:item,
        fileType:this.getFileType(lastName)
      }
    })
  },
  methods: {
    getFileType(v){
      const types = new Map([
        ['.pdf',1],
        ['.docx',2],
        ['.doc',1],
      ])
      return types.get(v)
    },
  },
};
</script>

<style scoped lang="scss">
$width: 50px;
$color: #ff8040;
.about {
  h1 {
    color: $color !important;
  }
}
</style>
